import { Pipe, PipeTransform } from '@angular/core';
import { ICartProduct } from '../../models/cart.model';
import { ShowCurrencyPipe } from './show-currency.pipe';

@Pipe({
  name: 'cartProductPrice'
})
export class CartProductPricePipe implements PipeTransform {

  /**
   *
   * @param cartProduct
   * @param forOne нужно ли посчитать стоимость за одну единицу в корзине или за все позиции
   */
  transform(cartProduct: ICartProduct, forOne = false): string {
    let price = cartProduct.price;
    for (let productGroup of cartProduct.groups) {
      for (let productGroupModifier of productGroup.modifiers) {
        price += productGroupModifier.calculatedPrice * productGroupModifier.selectedQuantity;
      }
    }
    const showCurrencyPipe = new ShowCurrencyPipe();
    if (forOne) {
      return showCurrencyPipe.transform(price);
    } else {
      return showCurrencyPipe.transform((price * cartProduct.quantity));
    }

  }

}
